import clsx from 'clsx'
import { cloneElement } from 'react'

import { Text } from '../../designs'

interface Props {
  stepNumber: number
  title: string
  icon: React.ReactElement
  description: string
  children: React.ReactNode
  isCompact?: boolean
}

const UserFlowStepContainer = ({
  stepNumber,
  title,
  description,
  icon,
  children,
  isCompact = false,
}: Props) => {
  return (
    <div className={clsx('flex gap-3', isCompact ? 'items-start py-3' : 'py-8')}>
      <div>
        {cloneElement(icon, {
          className: clsx(
            'flex-none text-blue-800',
            isCompact ? 'size-9 text-primary-700' : 'size-15 lg:mx-6 xl:mx-8',
          ),
        })}
      </div>

      <div className='w-full'>
        <Text
          size='s'
          weight={600}
          className={clsx('capitalize !text-blue-800', isCompact ? 'mb-0' : 'mb-0.5')}
        >
          Task {stepNumber}
        </Text>
        <Text size='l' weight={500} variant='h3' className={clsx(isCompact ? 'mb-2' : 'mb-4')}>
          {title}
        </Text>

        <Text size='s' className={clsx(isCompact ? 'mb-3' : 'mb-4')}>
          {description}
        </Text>

        {children}
      </div>
    </div>
  )
}

export default UserFlowStepContainer

